import React from 'react'

function collectAccordionEventKeys(child, keys) {
  if (!React.isValidElement(child)) {
    return
  }

  if (child.type === React.Fragment) {
    React.Children.forEach(child.props.children, (fragmentChild) => {
      collectAccordionEventKeys(fragmentChild, keys)
    })
    return
  }

  const { eventKey } = child.props ?? {}
  if (eventKey != null) {
    keys.push(eventKey)
  }
}

export function getAccordionEventKeysFromChildren(children) {
  const keys = []

  React.Children.forEach(children, (child) => {
    collectAccordionEventKeys(child, keys)
  })

  return keys
}
